import { named, withDependencies } from '@wix/thunderbolt-ioc'
import type { PlatformEnvDataProvider } from '@wix/thunderbolt-symbols'
import { SiteFeatureConfigSymbol } from '@wix/thunderbolt-symbols'
import type { CustomUrlMapperSiteConfig } from './types'
import { name } from './symbols'

export const platformEnvDataProvider = withDependencies(
	[named(SiteFeatureConfigSymbol, name)],
	(customUrlMapperSiteConfig: CustomUrlMapperSiteConfig): PlatformEnvDataProvider => {
		return {
			platformEnvData() {
				return {
					customUrlMapper: {
						urlMappings: customUrlMapperSiteConfig.urlMappings,
						baseUrl: customUrlMapperSiteConfig.baseUrl,
					},
				}
			},
		}
	}
)
